/* This Navigation requires Tailwind CSS v2.0+ */

import { Fragment, useContext } from "react";
import { Disclosure, Menu, Transition } from "@headlessui/react";
import { HomeIcon } from "@heroicons/react/outline";

import { NavLink, useHistory } from "react-router-dom";
import { roleCheck } from "../../services/utils";
import AuthService from "../../services/AuthService";
import { AuthContext } from "../../context/AuthContext";

const navigation = [
  {
    name: "Vabatahtlikud",
    href: "/volunteers",
    current: true,
    showTo: ["super_admin", "admin", "coordinator", "som"],
  },
  {
    name: "Abivajajad",
    href: "/clients",
    current: false,
    showTo: ["volunteer", "super_admin", "admin", "coordinator", "som"],
  },
  {
    name: "Külastused",
    href: "/visits",
    current: false,
    showTo: ["super_admin", "admin", "coordinator", "volunteer"],
  },
  {
    name: "Raportid",
    href: "/reports",
    current: false,
    showTo: ["super_admin", "admin", "coordinator", "som"],
  },
  {
    name: "Dokumendid",
    href: "/documents",
    current: false,
    showTo: ["super_admin", "admin", "coordinator"],
  },
];

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function Navigation() {
  const history = useHistory();

  const { authenticated, user, logout } = useContext(AuthContext);

  const signOut = async () => {
    await logout();
    history.push("/login");
  };
  return (
    <Disclosure as="nav" className="bg-indigo-500">
      {({ open }) => (
        <>
          <div className="max-w-7xl mx-auto px-2 sm:px-6 lg:px-8">
            <div className="relative flex items-center justify-between h-16">
              <div className="absolute inset-y-0 left-0 flex items-center sm:hidden">
                <a href="/" className="block md:hidden text-white">
                  <HomeIcon className="h-6 w-6" />
                </a>

                {/* Mobile menu button*/}
                {/* 
                <Disclosure.Button className="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-white hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white">
                  <span className="sr-only">Open main menu</span>
                  {open ? (
                    <XIcon className="block h-6 w-6" aria-hidden="true" />
                  ) : (
                    <MenuIcon className="block h-6 w-6" aria-hidden="true" />
                  )}
                </Disclosure.Button> */}
              </div>
              <div className="flex-1 flex items-center justify-center sm:items-stretch sm:justify-start">
                <div className="flex-shrink-0 flex items-center">
                  <NavLink to="/dashboard">
                    <h3 className="text-white">Vabatahtlike andmebaas</h3>
                  </NavLink>
                </div>
                {authenticated && (
                  <div className="hidden sm:block sm:ml-6">
                    <div className="flex space-x-4">
                      {navigation.map(
                        (item) =>
                          roleCheck(user.roles, item.showTo) && (
                            <NavLink
                              key={item.name}
                              to={item.href}
                              disabled={item.disabled === true}
                              className={(isActive) =>
                                "px-3 py-2 rounded-md text-sm font-medium " +
                                (isActive
                                  ? "bg-gray-900 text-white"
                                  : "text-gray-300 hover:bg-gray-700 hover:text-white")
                              }
                              aria-current={item.current ? "page" : undefined}
                            >
                              {item.name}
                            </NavLink>
                          )
                      )}
                    </div>
                  </div>
                )}
              </div>
              <div className="absolute inset-y-0 right-0 flex items-center pr-2 sm:static sm:inset-auto sm:ml-6 sm:pr-0">
                {/* <button
                  type="button"
                  className="bg-gray-800 p-1 rounded-full text-gray-400 hover:text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-white"
                >
                  <span className="sr-only">View notifications</span>
                  <BellIcon className="h-6 w-6" aria-hidden="true" />
                </button> */}
                {/* <h3>{user && user.name}</h3> */}

                {/* Profile dropdown */}
                <Menu as="div" className="ml-3 relative flex items-center">
                  <div className="items-center">
                    <Menu.Button>
                      <span className="sr-only">Open user menu</span>
                      {/* <img
                        className="h-8 w-8 rounded-full"
                        src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"
                        alt=""
                      /> */}
                      <span className="icon-user text-3xl text-white mb-6"></span>
                    </Menu.Button>
                  </div>
                  <Transition
                    as={Fragment}
                    enter="transition ease-out duration-100"
                    enterFrom="transform opacity-0 scale-95"
                    enterTo="transform opacity-100 scale-100"
                    leave="transition ease-in duration-75"
                    leaveFrom="transform opacity-100 scale-100"
                    leaveTo="transform opacity-0 scale-95"
                  >
                    <Menu.Items className="origin-top-right absolute right-0 top-10 mt-2 w-48 rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5 focus:outline-none">
                      {/* <Menu.Item>
                        {({ authenticated }) => (
                          <button
                            className={classNames(
                              authenticated ? "bg-gray-100" : "",
                              "block px-4 py-2 text-sm text-gray-700"
                            )}
                          >
                            Sinu profiil
                          </button>
                        )}
                      </Menu.Item> */}
                      {/* <Menu.Item>
                        {({ authenticated }) => (
                          <button
                            className={classNames(
                              authenticated ? "bg-gray-100" : "",
                              "block px-4 py-2 text-sm text-gray-700"
                            )}
                          >
                            Sätted
                          </button>
                        )}
                      </Menu.Item> */}
                      <Menu.Item>
                        {({ authenticated }) => (
                          <button
                            onClick={signOut}
                            className={classNames(
                              authenticated ? "bg-gray-100" : "",
                              "block px-4 py-2 text-sm text-gray-700"
                            )}
                          >
                            Logi välja
                          </button>
                        )}
                      </Menu.Item>
                    </Menu.Items>
                  </Transition>
                </Menu>
              </div>
            </div>
          </div>

          <Disclosure.Panel className="sm:hidden">
            <div className="px-2 pt-2 pb-3 space-y-1">
              {navigation.map((item) => (
                <NavLink
                  key={item.name}
                  to={item.href}
                  className={classNames(
                    item.current
                      ? "bg-gray-900 text-white"
                      : "text-gray-300 hover:bg-gray-700 hover:text-white",
                    "block px-3 py-2 rounded-md text-base font-medium"
                  )}
                  aria-current={item.current ? "page" : undefined}
                >
                  {item.name}
                </NavLink>
              ))}
            </div>
          </Disclosure.Panel>
        </>
      )}
    </Disclosure>
  );
}
